export const copyToClipboard = (displayAlert, text, description) => {
  description ||= 'Value'
  if (navigator.clipboard) {
    navigator.clipboard.writeText(text).
      then(_ => {
        displayAlert('success', `${description} copied to the clipboard`)
      }).
      catch(_ => {
        displayAlert('error', `There was an error copying the ${description} to the clipboard`)
      })
    return
  }
  try {
    const el = document.createElement('textarea')
    el.value = text
    el.style.position = 'fixed'
    el.style.opacity = '0'
    document.body.appendChild(el)
    el.select()
    document.execCommand('copy')
    document.body.removeChild(el)
    displayAlert('success', `${description} copied to the clipboard`)
  } catch {
    displayAlert('error', `There was an error copying the ${description} to the clipboard`)
  }
}
